import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { Notice } from "../../lib/ui";
import { printHtml } from "../../lib/format";
import { grnHtml } from "../../lib/hrDocs";

/* Goods received notes – port of callGrn.php / GRNcall.php (API: /api/grns, /api/grns/<id>/print).
   Pick a GRN and print it as an A4 document (save as PDF from the print dialog). */


export default function GrnList() {
  const api = useApi();
  const [rows, setRows] = useState(null);
  const [sel, setSel] = useState("");
  const [error, setError] = useState(null);
  useEffect(() => { api.get("/api/grns").then(setRows).catch((e) => setError(e.message)); }, [api]);
  return (
    <main className="pg" style={{ maxWidth: "46rem" }}>
      <PageHeader slug="callGrn" />
      <Notice notice={error && { tone: "err", text: error }} />
      <section className="panel" style={{ padding: "1.25rem" }}>
        <div className="field"><label htmlFor="grn">Goods received note</label>
          <select id="grn" value={sel} onChange={(e) => setSel(e.target.value)}>
            <option value="">Select GRN</option>{(rows || []).map((g) => <option key={g.grn_id} value={g.grn_id}>GRN #{g.grn_id} – PO #{g.po_id} ({String(g.received_date).slice(0, 10)})</option>)}
          </select></div>
        <div style={{ marginTop: "1rem", display: "flex", gap: ".6rem", alignItems: "center" }}>
          <button type="button" className="btn primary" disabled={!sel} onClick={async () => { try { printHtml(grnHtml(await api.get(`/api/grns/${sel}/print`))); } catch (e) { setError(e.message); } }}>
            <i className="fas fa-print" /> Print GRN / save PDF</button>
        </div>
      </section>
    </main>
  );
}
